import { Injectable, Inject, forwardRef,} from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository,Raw, getConnection } from 'typeorm';
import { ProfileService } from '../profile/profile.service';
import { CMRFEntity } from './cmrf.entity';
import { sendFCMNotifications, sendTextLocalSMS } from '../shared/mobileOTP';
import { CMRFDTO, DeleteDTO } from './dto/cmrf.dto';
import { AllCMRFResponseModel, CMRFResponseModel, SingleCMRFResponseModel } from './dto/cmrf-response-model';


@Injectable()
export class CMRFService {
  constructor(
    @InjectRepository(CMRFEntity)
    private chRep: Repository<CMRFEntity>,
    @Inject(forwardRef(()=>ProfileService))
    private profileService: ProfileService,
  ) {}

  async sendSMS(mobileNo:string, text: string, id:string) {
    return await sendTextLocalSMS(mobileNo, text, id)
    .then(() => {      
    console.log('sms sent successufully');
    return true;
    })
    .catch((err) => {
    console.log('error in sending sms ', err);
    return false;
    });
  }

  async sendNotify(text) {
    return await sendFCMNotifications(text)
    .then(() => {      
      console.log('notification sent successufully');
      return true;
    })
    .catch((err) => {
      console.log('error in sending notification ', err);
      return false;
    });
  }

  
  async createCMRF(queryParams,cyDto:CMRFDTO): Promise<CMRFResponseModel> {
    cyDto.status  = true;
      const response = new CMRFResponseModel();
      try {
              if(queryParams.apiVersion == 1) {
               
                const savedWelfare = await this.chRep.save(cyDto);
                
                  
                  if (savedWelfare) {
                    response.status = true;
                    response.data = savedWelfare;
                    response.statusCode = 50000;
                    response.internalMessage = 'Record created successfully';
                    response.intlCode = 11100;
                  } else {
                    throw new ErrorResponse(11106, 'Record not created');
                  }
                } else {
                  const savedWelfare = await this.chRep.save(cyDto);
                  if (savedWelfare) {
                    response.status = true;
                    response.data = savedWelfare;
                    response.statusCode = 50000;
                    response.internalMessage = 'Record created successfully';
                    response.intlCode = 11100;
                  } else {
                    throw new ErrorResponse(11106, 'Record not created');
                  }
              }
          
          return response;
      }
     
      catch (error) {
          throw error;
      }
  
  }  
  

  async updateCMRF(queryParams, cyDto:CMRFDTO, request:Request): Promise<SingleCMRFResponseModel> {
    const response = new SingleCMRFResponseModel();
    try {
      const oldData = await this.chRep.findOne({
        where:{Id:cyDto.Id}
      })
      if(cyDto.applicationNo) {
        cyDto.applicationNo = cyDto.applicationNo
      } else {
        cyDto.applicationNo = oldData.applicationNo
      }
      if(cyDto.namePrefix) {
        cyDto.namePrefix = cyDto.namePrefix
      } else {
        cyDto.namePrefix = oldData.namePrefix
      }
      if(cyDto.applicantName) {
        cyDto.applicantName = cyDto.applicantName
      } else {
        cyDto.applicantName = oldData.applicantName
      }
      if(cyDto.applicantGender) {
        cyDto.applicantGender = cyDto.applicantGender
      } else {
        cyDto.applicantGender = oldData.applicantGender
      }
      if(cyDto.prefixRelation) {
        cyDto.prefixRelation = cyDto.prefixRelation
      } else {
        cyDto.prefixRelation = oldData.prefixRelation
      }
      if(cyDto.fatherOrHusbandName) {
        cyDto.fatherOrHusbandName = cyDto.fatherOrHusbandName
      } else {
        cyDto.fatherOrHusbandName = oldData.fatherOrHusbandName
      }
      if(cyDto.nomineeRelation) {
        cyDto.nomineeRelation = cyDto.nomineeRelation
      } else {
        cyDto.nomineeRelation = oldData.nomineeRelation
      }
      if(cyDto.nomineeAge) {
        cyDto.nomineeAge = cyDto.nomineeAge
      } else {
        cyDto.nomineeAge = oldData.nomineeAge
      }
      if(cyDto.village) {
        cyDto.village = cyDto.village
      } else {
        cyDto.village = oldData.village
      }
      if(cyDto.mandal) {
        cyDto.mandal = cyDto.mandal
      } else {
        cyDto.mandal = oldData.mandal
      }
      if(cyDto.district) {
        cyDto.district = cyDto.district
      } else {
        cyDto.district = oldData.district
      }
      if(cyDto.applicationReceivedDate) {
        cyDto.applicationReceivedDate = cyDto.applicationReceivedDate
      } else {
        cyDto.applicationReceivedDate = oldData.applicationReceivedDate
      }
      if(cyDto.mobileNo) {
        cyDto.mobileNo = cyDto.mobileNo
      } else {
        cyDto.mobileNo = oldData.mobileNo
      }
      if(cyDto.aadharNo) {
        cyDto.aadharNo = cyDto.aadharNo
      } else {
        cyDto.aadharNo = oldData.aadharNo
      }
      if(cyDto.nomineeAadharNo) {
        cyDto.nomineeAadharNo = cyDto.nomineeAadharNo
      } else {
        cyDto.nomineeAadharNo = oldData.nomineeAadharNo
      }
      if(cyDto.age) {
        cyDto.age = cyDto.age
      } else {
        cyDto.age = oldData.age
      }
      if(cyDto.houseNo) {
        cyDto.houseNo = cyDto.houseNo
      } else {
        cyDto.houseNo = oldData.houseNo
      }
      if(cyDto.pinNo) {
        cyDto.pinNo = cyDto.pinNo
      } else {
        cyDto.pinNo = oldData.pinNo
      }
      if(cyDto.RationOrIncomeNo) {
        cyDto.RationOrIncomeNo = cyDto.RationOrIncomeNo
      } else {
        cyDto.RationOrIncomeNo = oldData.RationOrIncomeNo
      }
      if(cyDto.hospitalName) {
        cyDto.hospitalName = cyDto.hospitalName
      } else {
        cyDto.hospitalName = oldData.hospitalName
      }
      if(cyDto.hospitalNo) {
        cyDto.hospitalNo = cyDto.hospitalNo
      } else {
        cyDto.hospitalNo = oldData.hospitalNo
      }
      if(cyDto.disease) {
        cyDto.disease = cyDto.disease
      } else {
        cyDto.disease = oldData.disease
      }
      if(cyDto.dod) {
        cyDto.dod = cyDto.dod
      } else {
        cyDto.dod = oldData.dod
      }
      if(cyDto.finalBillAmount) {
        cyDto.finalBillAmount = cyDto.finalBillAmount
      } else {
        cyDto.finalBillAmount = oldData.finalBillAmount
      }
      if(cyDto.finalBillAmountInWords) {
        cyDto.finalBillAmountInWords = cyDto.finalBillAmountInWords
      } else {
        cyDto.finalBillAmountInWords = oldData.finalBillAmountInWords
      }
      if(cyDto.fileSentDate) {
        cyDto.fileSentDate = cyDto.fileSentDate
      } else {
        cyDto.fileSentDate = oldData.fileSentDate
      }
      if(cyDto.printDate) {
        cyDto.printDate = cyDto.printDate
      } else {
        cyDto.printDate = oldData.printDate
      }
      if(cyDto.reference) {
        cyDto.reference = cyDto.reference
      } else {
        cyDto.reference = oldData.reference
      }
      if(cyDto.remarks) {
        cyDto.remarks = cyDto.remarks
      } else {
        cyDto.remarks = oldData.remarks
      }
      if(cyDto.chequeReceivedOrNot) {
        cyDto.chequeReceivedOrNot = cyDto.chequeReceivedOrNot
      } else {
        cyDto.chequeReceivedOrNot = oldData.chequeReceivedOrNot
      }
      if(cyDto.chequeNo) {
        cyDto.chequeNo = cyDto.chequeNo
      } else {
        cyDto.chequeNo = oldData.chequeNo
      }
      if(cyDto.date) {
        cyDto.date = cyDto.date
      } else {
        cyDto.date = oldData.date
      }
      if(cyDto.receivedAmountFromCMOffice) {
        cyDto.receivedAmountFromCMOffice = cyDto.receivedAmountFromCMOffice
      } else {
        cyDto.receivedAmountFromCMOffice = oldData.receivedAmountFromCMOffice
      }
      if(cyDto.chequeDistrubtionDate) {
        cyDto.chequeDistrubtionDate = cyDto.chequeDistrubtionDate
      } else {
        cyDto.chequeDistrubtionDate = oldData.chequeDistrubtionDate
      }      
      cyDto.updatedUser = cyDto.updatedUser;
      let finaObj = {
        applicationNo:cyDto.applicationNo,
        namePrefix:cyDto.namePrefix,
        applicantName:cyDto.applicantName,
        applicantGender:cyDto.applicantGender,
        prefixRelation:cyDto.prefixRelation,
        fatherOrHusbandName:cyDto.fatherOrHusbandName,
        nomineeRelation:cyDto.nomineeRelation,
        nomineeAge:cyDto.nomineeAge,
        village:cyDto.village,
        mandal:cyDto.mandal,
        district:cyDto.district,
        applicationReceivedDate:cyDto.applicationReceivedDate,
        mobileNo:cyDto.mobileNo,
        aadharNo:cyDto.aadharNo,
        nomineeAadharNo:cyDto.nomineeAadharNo,
        age:cyDto.age,
        houseNo:cyDto.houseNo,
        pinNo:cyDto.pinNo,
        RationOrIncomeNo:cyDto.RationOrIncomeNo,
        hospitalName:cyDto.hospitalName,
        hospitalNo:cyDto.hospitalNo,
        disease:cyDto.disease,
        dod:cyDto.dod,
        finalBillAmount:cyDto.finalBillAmount,
        finalBillAmountInWords:cyDto.finalBillAmountInWords,
        fileSentDate:cyDto.fileSentDate,
        printDate:cyDto.printDate,
        reference:cyDto.reference,
        remarks:cyDto.remarks,
        chequeReceivedOrNot:cyDto.chequeReceivedOrNot,
        chequeNo:cyDto.chequeNo,
        date:cyDto.date,
        receivedAmountFromCMOffice:cyDto.receivedAmountFromCMOffice,
        chequeDistrubtionDate:cyDto.chequeDistrubtionDate,        
        updatedUser:cyDto.updatedUser
      }
      if(queryParams.apiVersion == 1) {
        const updatePostType = await this.chRep.update(cyDto.Id, finaObj);       
        const welfareRespone = await this.chRep.findOne({
          where:{Id:cyDto.Id}
        });
        if (welfareRespone) {
          const user = await this.profileService.getUserByUId(welfareRespone.updatedUser);
          if(user){
            var pic = user.profilePic;
          } else {
            var pic = '';
          }
          const final = {
            Id: welfareRespone.Id,
            applicationNo:welfareRespone.applicationNo,
            namePrefix:welfareRespone.namePrefix,
            applicantName:welfareRespone.applicantName,
            applicantGender:welfareRespone.applicantGender,
            prefixRelation:welfareRespone.prefixRelation,
            fatherOrHusbandName:welfareRespone.fatherOrHusbandName,
            nomineeRelation:welfareRespone.nomineeRelation,
            nomineeAge:welfareRespone.nomineeAge,
            village:welfareRespone.village,
            mandal:welfareRespone.mandal,
            district:welfareRespone.district,
            applicationReceivedDate:welfareRespone.applicationReceivedDate,
            mobileNo:welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            nomineeAadharNo:welfareRespone.nomineeAadharNo,
            age:welfareRespone.age,
            houseNo:welfareRespone.houseNo,
            pinNo:welfareRespone.pinNo,
            RationOrIncomeNo:welfareRespone.RationOrIncomeNo,
            hospitalName:welfareRespone.hospitalName,
            hospitalNo:welfareRespone.hospitalNo,
            disease:welfareRespone.disease,
            dod:welfareRespone.dod,
            finalBillAmount:welfareRespone.finalBillAmount,
            finalBillAmountInWords:welfareRespone.finalBillAmountInWords,
            fileSentDate:welfareRespone.fileSentDate,
            printDate:welfareRespone.printDate,
            reference:welfareRespone.reference,
            remarks:welfareRespone.remarks,
            chequeReceivedOrNot:welfareRespone.chequeReceivedOrNot,
            chequeNo:welfareRespone.chequeNo,
            date:welfareRespone.date,
            receivedAmountFromCMOffice:welfareRespone.receivedAmountFromCMOffice,
            chequeDistrubtionDate:welfareRespone.chequeDistrubtionDate, 
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.createdUser,
            userName: user!=null?user.firstName:'',
            profilePic: pic != '' ? `${process.env.WORKINGURL}/${pic}` : ''
          }
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'Record updated';
          response.intlCode = 11108;
          response.data = final;
        } else {
          throw new ErrorResponse(99998, 'Record update failed');
        }
      } else  {
        const updatePostType = await this.chRep.update(cyDto.Id, finaObj);       
        const welfareRespone = await this.chRep.findOne({
          where:{Id:cyDto.Id}
        });
        if (welfareRespone) {
          const user = await this.profileService.getUserByUId(welfareRespone.updatedUser);
          if(user){
            var pic = user.profilePic;
          } else {
            var pic = '';
          }
          const final = {
            Id: welfareRespone.Id,
            applicationNo:welfareRespone.applicationNo,
            namePrefix:welfareRespone.namePrefix,
            applicantName:welfareRespone.applicantName,
            applicantGender:welfareRespone.applicantGender,
            prefixRelation:welfareRespone.prefixRelation,
            fatherOrHusbandName:welfareRespone.fatherOrHusbandName,
            nomineeRelation:welfareRespone.nomineeRelation,
            nomineeAge:welfareRespone.nomineeAge,
            village:welfareRespone.village,
            mandal:welfareRespone.mandal,
            district:welfareRespone.district,
            applicationReceivedDate:welfareRespone.applicationReceivedDate,
            mobileNo:welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            nomineeAadharNo:welfareRespone.nomineeAadharNo,
            age:welfareRespone.age,
            houseNo:welfareRespone.houseNo,
            pinNo:welfareRespone.pinNo,
            RationOrIncomeNo:welfareRespone.RationOrIncomeNo,
            hospitalName:welfareRespone.hospitalName,
            hospitalNo:welfareRespone.hospitalNo,
            disease:welfareRespone.disease,
            dod:welfareRespone.dod,
            finalBillAmount:welfareRespone.finalBillAmount,
            finalBillAmountInWords:welfareRespone.finalBillAmountInWords,
            fileSentDate:welfareRespone.fileSentDate,
            printDate:welfareRespone.printDate,
            reference:welfareRespone.reference,
            remarks:welfareRespone.remarks,
            chequeReceivedOrNot:welfareRespone.chequeReceivedOrNot,
            chequeNo:welfareRespone.chequeNo,
            date:welfareRespone.date,
            receivedAmountFromCMOffice:welfareRespone.receivedAmountFromCMOffice,
            chequeDistrubtionDate:welfareRespone.chequeDistrubtionDate, 
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.createdUser,
            userName: user!=null?user.firstName:'',
            profilePic: pic != '' ? `${process.env.WORKINGURL}/${pic}` : ''
          }
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'Record updated';
          response.intlCode = 11108;
          response.data = final;
        } else {
          throw new ErrorResponse(99998, 'Record update failed');
        }
      } 
      return response;
    } catch (error) {
      throw error;
    }    
  }

  async getAllCMRF(queryParams,userId, request:Request): Promise<AllCMRFResponseModel>{
    const response = new AllCMRFResponseModel();
    try{
      const finalData: any[] = [];
      const user = await this.profileService.getUserByUId(userId);
      if(user){
        var pic = user.profilePic;
      } else {
        var pic = '';
      }
      if (queryParams.apiVersion == 1) {
        var welfare = await this.chRep.find({
            where: {status: true,createdUser:userId},
            order: { createdAt: 'DESC' },
            skip:queryParams.skip,
            take:10 
        });
        
       
        if(!welfare) {
          throw new ErrorResponse(99908,'Data not found')
        }
        const promises = welfare.map(async (welfareRespone) => {
          const user = await this.profileService.getUserByUId(welfareRespone.createdUser);
          return {
            Id: welfareRespone.Id,
            applicationNo:welfareRespone.applicationNo,
            namePrefix:welfareRespone.namePrefix,
            applicantName:welfareRespone.applicantName,
            applicantGender:welfareRespone.applicantGender,
            prefixRelation:welfareRespone.prefixRelation,
            fatherOrHusbandName:welfareRespone.fatherOrHusbandName,
            nomineeRelation:welfareRespone.nomineeRelation,
            nomineeAge:welfareRespone.nomineeAge,
            village:welfareRespone.village,
            mandal:welfareRespone.mandal,
            district:welfareRespone.district,
            applicationReceivedDate:welfareRespone.applicationReceivedDate,
            mobileNo:welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            nomineeAadharNo:welfareRespone.nomineeAadharNo,
            age:welfareRespone.age,
            houseNo:welfareRespone.houseNo,
            pinNo:welfareRespone.pinNo,
            RationOrIncomeNo:welfareRespone.RationOrIncomeNo,
            hospitalName:welfareRespone.hospitalName,
            hospitalNo:welfareRespone.hospitalNo,
            disease:welfareRespone.disease,
            dod:welfareRespone.dod,
            finalBillAmount:welfareRespone.finalBillAmount,
            finalBillAmountInWords:welfareRespone.finalBillAmountInWords,
            fileSentDate:welfareRespone.fileSentDate,
            printDate:welfareRespone.printDate,
            reference:welfareRespone.reference,
            remarks:welfareRespone.remarks,
            chequeReceivedOrNot:welfareRespone.chequeReceivedOrNot,
            chequeNo:welfareRespone.chequeNo,
            date:welfareRespone.date,
            receivedAmountFromCMOffice:welfareRespone.receivedAmountFromCMOffice,
            chequeDistrubtionDate:welfareRespone.chequeDistrubtionDate, 
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.createdUser,
            userName: user!=null?user.firstName:'',
            profilePic: pic != '' ? `${process.env.WORKINGURL}/${pic}` : ''
          }   
        });   
        const da = await Promise.all(promises);
        da.map((welfareRespone) => {                                   
            finalData.push({
              Id: welfareRespone.Id,
            applicationNo:welfareRespone.applicationNo,
            namePrefix:welfareRespone.namePrefix,
            applicantName:welfareRespone.applicantName,
            applicantGender:welfareRespone.applicantGender,
            prefixRelation:welfareRespone.prefixRelation,
            fatherOrHusbandName:welfareRespone.fatherOrHusbandName,
            nomineeRelation:welfareRespone.nomineeRelation,
            nomineeAge:welfareRespone.nomineeAge,
            village:welfareRespone.village,
            mandal:welfareRespone.mandal,
            district:welfareRespone.district,
            applicationReceivedDate:welfareRespone.applicationReceivedDate,
            mobileNo:welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            nomineeAadharNo:welfareRespone.nomineeAadharNo,
            age:welfareRespone.age,
            houseNo:welfareRespone.houseNo,
            pinNo:welfareRespone.pinNo,
            RationOrIncomeNo:welfareRespone.RationOrIncomeNo,
            hospitalName:welfareRespone.hospitalName,
            hospitalNo:welfareRespone.hospitalNo,
            disease:welfareRespone.disease,
            dod:welfareRespone.dod,
            finalBillAmount:welfareRespone.finalBillAmount,
            finalBillAmountInWords:welfareRespone.finalBillAmountInWords,
            fileSentDate:welfareRespone.fileSentDate,
            printDate:welfareRespone.printDate,
            reference:welfareRespone.reference,
            remarks:welfareRespone.remarks,
            chequeReceivedOrNot:welfareRespone.chequeReceivedOrNot,
            chequeNo:welfareRespone.chequeNo,
            date:welfareRespone.date,
            receivedAmountFromCMOffice:welfareRespone.receivedAmountFromCMOffice,
            chequeDistrubtionDate:welfareRespone.chequeDistrubtionDate, 
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.userId,
            userName: welfareRespone.userName,
            profilePic: welfareRespone.profilePic                 
            }) 
        }) 
            
        response.status = true;
          response.data = finalData; 
          response.statusCode = 50000;
          response.internalMessage = 'Data retrived successfully';
          response.intlCode = 11108;  
        
      } else {
        var welfare = await this.chRep.find({
            where: {status: true,createdUser:userId},
            order: { createdAt: 'DESC' },
            skip:queryParams.skip,
            take:10 
        });
        
       
        if(!welfare) {
          throw new ErrorResponse(99908,'Data not found')
        }
        const promises = welfare.map(async (welfareRespone) => {
          const user = await this.profileService.getUserByUId(welfareRespone.createdUser);
          return {
            Id: welfareRespone.Id,
            applicationNo:welfareRespone.applicationNo,
            namePrefix:welfareRespone.namePrefix,
            applicantName:welfareRespone.applicantName,
            applicantGender:welfareRespone.applicantGender,
            prefixRelation:welfareRespone.prefixRelation,
            fatherOrHusbandName:welfareRespone.fatherOrHusbandName,
            nomineeRelation:welfareRespone.nomineeRelation,
            nomineeAge:welfareRespone.nomineeAge,
            village:welfareRespone.village,
            mandal:welfareRespone.mandal,
            district:welfareRespone.district,
            applicationReceivedDate:welfareRespone.applicationReceivedDate,
            mobileNo:welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            nomineeAadharNo:welfareRespone.nomineeAadharNo,
            age:welfareRespone.age,
            houseNo:welfareRespone.houseNo,
            pinNo:welfareRespone.pinNo,
            RationOrIncomeNo:welfareRespone.RationOrIncomeNo,
            hospitalName:welfareRespone.hospitalName,
            hospitalNo:welfareRespone.hospitalNo,
            disease:welfareRespone.disease,
            dod:welfareRespone.dod,
            finalBillAmount:welfareRespone.finalBillAmount,
            finalBillAmountInWords:welfareRespone.finalBillAmountInWords,
            fileSentDate:welfareRespone.fileSentDate,
            printDate:welfareRespone.printDate,
            reference:welfareRespone.reference,
            remarks:welfareRespone.remarks,
            chequeReceivedOrNot:welfareRespone.chequeReceivedOrNot,
            chequeNo:welfareRespone.chequeNo,
            date:welfareRespone.date,
            receivedAmountFromCMOffice:welfareRespone.receivedAmountFromCMOffice,
            chequeDistrubtionDate:welfareRespone.chequeDistrubtionDate, 
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.createdUser,
            userName: user!=null?user.firstName:'',
            profilePic: pic != '' ? `${process.env.WORKINGURL}/${pic}` : ''
          }   
        });   
        const da = await Promise.all(promises);
        da.map((welfareRespone) => {                                   
            finalData.push({
              Id: welfareRespone.Id,
            applicationNo:welfareRespone.applicationNo,
            namePrefix:welfareRespone.namePrefix,
            applicantName:welfareRespone.applicantName,
            applicantGender:welfareRespone.applicantGender,
            prefixRelation:welfareRespone.prefixRelation,
            fatherOrHusbandName:welfareRespone.fatherOrHusbandName,
            nomineeRelation:welfareRespone.nomineeRelation,
            nomineeAge:welfareRespone.nomineeAge,
            village:welfareRespone.village,
            mandal:welfareRespone.mandal,
            district:welfareRespone.district,
            applicationReceivedDate:welfareRespone.applicationReceivedDate,
            mobileNo:welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            nomineeAadharNo:welfareRespone.nomineeAadharNo,
            age:welfareRespone.age,
            houseNo:welfareRespone.houseNo,
            pinNo:welfareRespone.pinNo,
            RationOrIncomeNo:welfareRespone.RationOrIncomeNo,
            hospitalName:welfareRespone.hospitalName,
            hospitalNo:welfareRespone.hospitalNo,
            disease:welfareRespone.disease,
            dod:welfareRespone.dod,
            finalBillAmount:welfareRespone.finalBillAmount,
            finalBillAmountInWords:welfareRespone.finalBillAmountInWords,
            fileSentDate:welfareRespone.fileSentDate,
            printDate:welfareRespone.printDate,
            reference:welfareRespone.reference,
            remarks:welfareRespone.remarks,
            chequeReceivedOrNot:welfareRespone.chequeReceivedOrNot,
            chequeNo:welfareRespone.chequeNo,
            date:welfareRespone.date,
            receivedAmountFromCMOffice:welfareRespone.receivedAmountFromCMOffice,
            chequeDistrubtionDate:welfareRespone.chequeDistrubtionDate, 
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.userId,
            userName: welfareRespone.userName,
            profilePic: welfareRespone.profilePic                 
            }) 
        }) 
            
        response.status = true;
          response.data = finalData; 
          response.statusCode = 50000;
          response.internalMessage = 'Data retrived successfully';
          response.intlCode = 11108;  
        
      } 
      return response;
    }catch( err) {
      throw err;
      }
  }

  async getCMRFById(queryParams, welfareId: number, request:Request): Promise<SingleCMRFResponseModel> {
      const response = new SingleCMRFResponseModel();
      try {
        if (queryParams.apiVersion == 1) {
          const welfareRespone = await this.chRep.findOne({
                      where:{Id:welfareId, status:true}
          });
          if (welfareRespone) {
            const user = await this.profileService.getUserByUId(welfareRespone.createdUser);   
            if(user){
              var pic = user.profilePic;
            } else {
              var pic = '';
            }         
            const final = {
              Id: welfareRespone.Id,
            applicationNo:welfareRespone.applicationNo,
            namePrefix:welfareRespone.namePrefix,
            applicantName:welfareRespone.applicantName,
            applicantGender:welfareRespone.applicantGender,
            prefixRelation:welfareRespone.prefixRelation,
            fatherOrHusbandName:welfareRespone.fatherOrHusbandName,
            nomineeRelation:welfareRespone.nomineeRelation,
            nomineeAge:welfareRespone.nomineeAge,
            village:welfareRespone.village,
            mandal:welfareRespone.mandal,
            district:welfareRespone.district,
            applicationReceivedDate:welfareRespone.applicationReceivedDate,
            mobileNo:welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            nomineeAadharNo:welfareRespone.nomineeAadharNo,
            age:welfareRespone.age,
            houseNo:welfareRespone.houseNo,
            pinNo:welfareRespone.pinNo,
            RationOrIncomeNo:welfareRespone.RationOrIncomeNo,
            hospitalName:welfareRespone.hospitalName,
            hospitalNo:welfareRespone.hospitalNo,
            disease:welfareRespone.disease,
            dod:welfareRespone.dod,
            finalBillAmount:welfareRespone.finalBillAmount,
            finalBillAmountInWords:welfareRespone.finalBillAmountInWords,
            fileSentDate:welfareRespone.fileSentDate,
            printDate:welfareRespone.printDate,
            reference:welfareRespone.reference,
            remarks:welfareRespone.remarks,
            chequeReceivedOrNot:welfareRespone.chequeReceivedOrNot,
            chequeNo:welfareRespone.chequeNo,
            date:welfareRespone.date,
            receivedAmountFromCMOffice:welfareRespone.receivedAmountFromCMOffice,
            chequeDistrubtionDate:welfareRespone.chequeDistrubtionDate, 
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.createdUser,
            userName: user!=null?user.firstName:'',
            profilePic: pic != '' ? `${process.env.WORKINGURL}/${pic}` : ''                    
            }
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'Record found';
            response.intlCode = 11107;
            response.data = final;
          } else {
            throw new ErrorResponse(99998, 'Record not found');
          }
        } else {
          const welfareRespone = await this.chRep.findOne({
                      where:{Id:welfareId, status:true}
          });
          if (welfareRespone) {
            const user = await this.profileService.getUserByUId(welfareRespone.createdUser);   
            if(user){
              var pic = user.profilePic;
            } else {
              var pic = '';
            }         
            const final = {
              Id: welfareRespone.Id,
            applicationNo:welfareRespone.applicationNo,
            namePrefix:welfareRespone.namePrefix,
            applicantName:welfareRespone.applicantName,
            applicantGender:welfareRespone.applicantGender,
            prefixRelation:welfareRespone.prefixRelation,
            fatherOrHusbandName:welfareRespone.fatherOrHusbandName,
            nomineeRelation:welfareRespone.nomineeRelation,
            nomineeAge:welfareRespone.nomineeAge,
            village:welfareRespone.village,
            mandal:welfareRespone.mandal,
            district:welfareRespone.district,
            applicationReceivedDate:welfareRespone.applicationReceivedDate,
            mobileNo:welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            nomineeAadharNo:welfareRespone.nomineeAadharNo,
            age:welfareRespone.age,
            houseNo:welfareRespone.houseNo,
            pinNo:welfareRespone.pinNo,
            RationOrIncomeNo:welfareRespone.RationOrIncomeNo,
            hospitalName:welfareRespone.hospitalName,
            hospitalNo:welfareRespone.hospitalNo,
            disease:welfareRespone.disease,
            dod:welfareRespone.dod,
            finalBillAmount:welfareRespone.finalBillAmount,
            finalBillAmountInWords:welfareRespone.finalBillAmountInWords,
            fileSentDate:welfareRespone.fileSentDate,
            printDate:welfareRespone.printDate,
            reference:welfareRespone.reference,
            remarks:welfareRespone.remarks,
            chequeReceivedOrNot:welfareRespone.chequeReceivedOrNot,
            chequeNo:welfareRespone.chequeNo,
            date:welfareRespone.date,
            receivedAmountFromCMOffice:welfareRespone.receivedAmountFromCMOffice,
            chequeDistrubtionDate:welfareRespone.chequeDistrubtionDate, 
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.createdUser,
            userName: user!=null?user.firstName:'',
            profilePic: pic != '' ? `${process.env.WORKINGURL}/${pic}` : ''                    
            }
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'Record found';
            response.intlCode = 11107;
            response.data = final;
          } else {
            throw new ErrorResponse(99998, 'Record not found');
          }
        }
        return response;
      } catch (error) {
        throw error;
      }
  }   

  async deleteRecord(queryParams,deleteDto:DeleteDTO, request:Request):Promise<CMRFResponseModel>{
      const response = new CMRFResponseModel();
      try {
        if(queryParams.apiVersion == 1) {
          const welfare =await this.chRep.update(deleteDto.Id,deleteDto);
          if (welfare) {
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'Record deleted successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'Record delete failed');
          }
        } else {
          const welfare =await this.chRep.update(deleteDto.Id,deleteDto);
          if (welfare) {
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'Record deleted successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'Record delete failed');
          }
        }      
        return response;
      } catch (error) {
        throw error;
      }
  }

 

}


